import { render } from "./reportInfo.vue?vue&type=template&id=85924f48&scoped=true&ts=true&lang=pug"
import script from "./reportInfo.vue?vue&type=script&lang=ts"
export * from "./reportInfo.vue?vue&type=script&lang=ts"

import "./reportInfo.vue?vue&type=style&index=0&id=85924f48&lang=stylus&scoped=true"

import exportComponent from "/builds/findsoft/hero/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-85924f48"]])

export default __exports__